import React from 'react';
import { Card, Row, Col, Space, Collapse, Tag, Table } from 'antd';
import { PROCESSING_FEE_TYPE } from '../../common/constants';

// 服务费明细
function ProcessingFee(props: any) {
    const { cart } = props || {};
    const { processingFeeRecord } = cart?.groups?.[0] || {};

    const dataSource = getDataSource(processingFeeRecord);
    const columns = [{
        title: 'itemId',
        dataIndex: 'itemId',
        key: 'itemId',
        width: '20%'
    }, {
        title: '服务费分类',
        dataIndex: 'type',
        key: 'type',
        width: '20%',
        render: (record) => PROCESSING_FEE_TYPE[record] ? PROCESSING_FEE_TYPE[record] : record
    }, {
        title: '比例',
        dataIndex: 'rate',
        key: 'rate',
        width: '20%',
        render: (record) => record + '%'
    }, {
        title: '金额',
        dataIndex: 'cents',
        key: 'cents',
        render: (record) => '$' + record/100
    }];

    if(!processingFeeRecord) return null;

    return <Card title="服务费明细" style={{ width: '100%' }}>
        <Space direction="vertical" size='middle' style={{ width: '100%' }}>
            <div>注：商家手续费是我们向商家收取的手续费，不是商家佣金，收费比例可能根据各个商品有差别</div>
            <Table
                dataSource={dataSource}
                columns={columns}
                pagination={false}
            />
        </Space>
    </Card>
}

function getDataSource(data) {
    let arr: any = [];
    Object.keys(data?.itemizedRecords || {})?.map(itemId => {
        const records = data?.itemizedRecords?.[itemId];
        records?.itemized?.map(item => {
            arr.push({
                itemId,
                ...item,
            })
        })
    })
    return arr;
}

export default ProcessingFee;